import React from 'react';
import { Dropdown, Tooltip, Icon, Menu } from 'antd';
import {
  useHasSelectedRooms,
  useRoomsSelectionActions,
} from '../../services/roomsSelection';
import Btn from '../../../../../../components/btn';
import { MassChangeLifeCycle } from '../../../../controllers/ChangeLifeCycle';
import { BsListCheck } from 'react-icons/bs';
import styles from './index.module.scss';

const MassActions = () => {
  const hasSelectedRooms = useHasSelectedRooms();

  if (!hasSelectedRooms) {
    return null;
  }

  return <Content />;
};

export default MassActions;

function Content() {
  const handleBtnClick = (e) => {
    e.stopPropagation();
  };

  return (
    <Dropdown trigger={['click']} overlay={<ActionsMenu />}>
      <Tooltip title="Массовые действия">
        <Btn className={styles.btn} onClick={handleBtnClick}>
          <Icon component={BsListCheck} />
        </Btn>
      </Tooltip>
    </Dropdown>
  );
}

function ActionsMenu(props) {
  const { getSelectedIds } = useRoomsSelectionActions();

  return (
    <Menu {...props}>
      <SelectStageChange getSelectedIds={getSelectedIds} />
      <SelectStepChange getSelectedIds={getSelectedIds} />
    </Menu>
  );
}

function SelectStageChange({ onClick, getSelectedIds, ...props }) {
  const { selectStageChange } = MassChangeLifeCycle.useActions();

  const handleClick = ({ domEvent }) => {
    domEvent.stopPropagation();
    onClick();
    selectStageChange(getSelectedIds());
  };

  return (
    <Menu.Item {...props} onClick={handleClick}>
      Изменить стадию
    </Menu.Item>
  );
}

function SelectStepChange({ onClick, getSelectedIds, ...props }) {
  const { selectStepChange } = MassChangeLifeCycle.useActions();

  const handleClick = ({ domEvent }) => {
    domEvent.stopPropagation();
    onClick();
    selectStepChange(getSelectedIds());
  };

  return (
    <Menu.Item {...props} onClick={handleClick}>
      Изменить этап
    </Menu.Item>
  );
}
